import axios from 'axios';

// Cambiar esta clave invalida todas las sesiones guardadas (útil en deploys con cambios de payload JWT)
export const STORAGE_KEY = 'auth_v2';

const api = axios.create();

// Adjunta el token en cada request automáticamente
api.interceptors.request.use((config) => {
    try {
        const auth = JSON.parse(localStorage.getItem(STORAGE_KEY));
        if (auth?.token) {
            config.headers.Authorization = `Bearer ${auth.token}`;
        }
    } catch {
        // Si el JSON está corrupto se ignora; AuthContext lo limpiará al cargar
    }
    return config;
});

// Si el backend responde 401, notifica a AuthContext para forzar logout
api.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response?.status === 401) {
            window.dispatchEvent(new Event('auth:unauthorized'));
        }
        return Promise.reject(error);
    }
);

export default api;
